import { i as m } from "../../../util-b2b0dc25.js";
import { addClass as r, removeClass as p } from "../dom.js";
let h = !1, g = !1, c;
const k = function() {
  if (m())
    return;
  let t = n.modalDom;
  return t ? h = !0 : (h = !1, t = document.createElement("div"), n.modalDom = t, t.addEventListener("touchmove", function(e) {
    e.preventDefault(), e.stopPropagation();
  }), t.addEventListener("click", function() {
    n.doOnModalClick && n.doOnModalClick();
  })), t;
}, f = {}, n = {
  modalFade: !0,
  getInstance: function(t) {
    return f[t];
  },
  register: function(t, e) {
    t && e && (f[t] = e);
  },
  deregister: function(t) {
    t && (f[t] = null, delete f[t]);
  },
  nextZIndex: function() {
    return n.zIndex++;
  },
  modalStack: [],
  doOnModalClick: function() {
    const t = n.modalStack[n.modalStack.length - 1];
    if (!t)
      return;
    const e = n.getInstance(t.id);
    e && e.closeOnClickModal && e.close();
  },
  openModal: function(t, e, o, a, i) {
    if (m() || !t || e === void 0)
      return;
    this.modalFade = i;
    const d = this.modalStack;
    for (let s = 0, u = d.length; s < u; s++)
      if (d[s].id === t)
        return;
    const l = k();
    r(l, "v-modal"), this.modalFade && !h && r(l, "v-modal-enter"), a && a.trim().split(/\s+/).forEach((u) => r(l, u)), setTimeout(() => {
      p(l, "v-modal-enter");
    }, 200), o && o.parentNode && o.parentNode.nodeType !== 11 ? o.parentNode.appendChild(l) : document.body.appendChild(l), e && (l.style.zIndex = e), l.tabIndex = 0, l.style.display = "", this.modalStack.push({ id: t, zIndex: e, modalClass: a });
  },
  closeModal: function(t) {
    const e = this.modalStack, o = k();
    if (e.length > 0) {
      const a = e[e.length - 1];
      if (a.id === t)
        a.modalClass && a.modalClass.trim().split(/\s+/).forEach((d) => p(o, d)), e.pop(), e.length > 0 && (o.style.zIndex = e[e.length - 1].zIndex);
      else
        for (let i = e.length - 1; i >= 0; i--)
          if (e[i].id === t) {
            e.splice(i, 1);
            break;
          }
    }
    e.length === 0 && (this.modalFade && r(o, "v-modal-leave"), setTimeout(() => {
      e.length === 0 && (o.parentNode && o.parentNode.removeChild(o), o.style.display = "none", n.modalDom = void 0), p(o, "v-modal-leave");
    }, 200));
  }
};
Object.defineProperty(n, "zIndex", {
  configurable: !0,
  get() {
    return g || (c = c || 2500, g = !0), c;
  },
  set(t) {
    c = t;
  }
});
const v = function() {
  if (!m() && n.modalStack.length > 0) {
    const t = n.modalStack[n.modalStack.length - 1];
    return t ? n.getInstance(t.id) : void 0;
  }
};
m() || window.addEventListener("keydown", function(t) {
  if (t.keyCode === 27) {
    const e = v();
    e && e.closeOnPressEscape && (e.handleClose ? e.handleClose() : e.handleAction ? e.handleAction("cancel") : e.close());
  }
});
export {
  n as default
};
